// @ts-nocheck

import { Button, HeaderSection, Icon } from '@lmc/ui-kit'
import React from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { Link } from 'react-router-dom'
import { isLowerThen564px } from '../../../common/utils'
import { history } from '../../../store'
import PdfExport from '../../pdf/PdfExport'
import SectionHeader from '../SectionHeader/SectionHeader'

export default function ScreenHeader({
  backLink,
  backText = 'Back',
  children, // Assumption is that all children are buttons
  editableTitle,
  pdfUrl,
  historyLink,
  title,
  pdfTitle,
  onSaveTitle,
  subtitle,
  useGoBack,
  isInnerChildren = false
  // toggles use of history.back() for back link
}) {
  const headerContainerStyle = {
    ...styles.headerContainer,
    justifyContent: backLink ? 'space-between' : 'flex-end',
    display: !children && !backLink && !historyLink ? 'none' : 'flex'
  }

  return (
    <div>
      <div style={headerContainerStyle}>
        {backLink &&
          (useGoBack ? (
            <a
              onClick={() => {
                history.back()
              }}
            >
              <Icon name="LeftOutlined" style={styles.backLink} />
              {`${backText}`}
            </a>
          ) : (
            <Link to={backLink}>
              <Icon name="LeftOutlined" style={styles.backLink} />
              {`${backText}`}
            </Link>
          ))}
        <div style={styles.buttonsContainer}>
          {!isInnerChildren && children}
          {historyLink && (
            <Button
              id="care-plan-history-button"
              style={styles.historyButton}
              onClick={() => {
                history.push(`${historyLink}`)
              }}
              icon={<Icon name="HistoryOutlined" />}
              variant="default"
            >
              History
            </Button>
          )}
        </div>
      </div>
      <div style={styles.titleContainer}>
        {!editableTitle ? (
          <HeaderSection
            flexColumn={isLowerThen564px}
            title={title}
            subtitle={subtitle}
            rightChildren={
              <div style={styles.innerContainer}>
                {isInnerChildren && children}
                <div>
                  {pdfUrl && (
                    <PdfExport
                      pdfTitle={pdfTitle}
                      url={pdfUrl}
                      text={isDesktop ? 'Download PDF' : 'PDF'}
                    />
                  )}
                </div>
              </div>
            }
          />
        ) : (
          <SectionHeader
            flexColumn={isLowerThen564px}
            title={title}
            editableTitle={editableTitle}
            onSaveTitle={onSaveTitle}
            subtitle={subtitle}
          />
        )}
      </div>
    </div>
  )
}

const isDesktop = isBrowser || isTablet

const styles = {
  backLink: {
    paddingRight: 5
  },
  buttonsContainer: {
    display: 'flex'
  },
  historyButton: {
    marginRight: 10
  },
  headerContainer: {
    display: 'flex'
    /*     minHeight: 24, */
  },
  titleContainer: {
    paddingTop: 24,
    marginBottom: 0
  },
  innerContainer: {
    display: 'flex'
  }
}
